<template>
    <div class="language" @mouseleave="openDialog = false">
        <div class="current" v-if="selectedLanguage">
            <div
                    @click="openDialog = true"
                    @mouseover="openDialog = true"
            >
                <div
                        class="flag"
                        :style="{backgroundImage: `url(${selectedLanguage.flag_img_path})`}"
                ></div>
            </div>
        </div>
        <div
                class="list"
                :class="{open: openDialog}"
        >
            <div class="">
                <ul>
                    <li
                            class="item"
                            v-for="language in languages"
                            :key="language.id"
                            @click="changeLocale(language)"
                    >
                        <img
                                :src="language.flag_img_path"
                                class="flag"
                        >
                        <span>
                            {{language.name}}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from "vue";
  import Spinner from "./Spinner";
  import EventBus from "../eventbus";
  import languages from './../lang/languages';

  export default {
      components: {
          Spinner
      },
      data(){
          return {
              languages: languages,
              selectedLanguage: null,
              openDialog: false,
          }
      },
      mounted(){
          const selectedLanguageCode = this.$i18n.locale;
          this.selectedLanguage = this.languages.find(lang => lang.code === selectedLanguageCode) || null;

          EventBus.$on('languageChanged', this.languageChangedHandler);
      },
      methods: {
          changeLocale(language){
              this.openDialog = false;
              EventBus.changeLanguage(language);
          },
          languageChangedHandler(language){
              this.selectedLanguage = language;
          }
      },
      beforeDestroy() {
          EventBus.$off('languageChanged', this.languageChangedHandler);
      }
  }
</script>

<style scoped lang="scss">
     @import './../styles/variables';

    .flag{
        cursor: pointer;
        height: 36px;
        width: 60px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .language{
        position: relative;

        .list{
            display: none;
            position: absolute;
            top: 36px;
            left: 0;
            width: 200px;
            height: auto;
            background-color: rgba(0,0,0,.75);
            color: #ffffff;
            z-index: 20;

            &.open{
                display: block;
            }

            ul{
                list-style: none;
                padding: 0 0;
                margin: 0 0;

                .item{
                    display: flex;
                    align-content: center;
                    text-align: left;
                    padding: 10px 10px;
                    line-height: 36px;
                    cursor: pointer;
                    transition: color 500ms ease, background-color 500ms ease;

                    &:hover{
                        background-color: $pallete_clear_color;
                        color: $pallete_dark_text_color;
                    }

                    img{
                        margin-right: 5px;
                    }
                }
            }
        }
    }
</style>
